import React, { useEffect } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { ActionTypeEnum, useDetailModel } from "./detailModel";


export const InfoBox = () => {

    const { setActionType, actionType, supplier, loadSummaryData } = useDetailModel();

    const onAccountList = () => {
        setActionType(ActionTypeEnum.ACCOUNT)
    }
    const onAdjustList = () => {
        setActionType(ActionTypeEnum.ADJUST_LIST)
    }
    const onRechargeList = () => {
        setActionType(ActionTypeEnum.RECHARGE_LIST)
    }
    const onTransferList = () => {
        setActionType(ActionTypeEnum.TRANSFER_LIst)
    }
    const onBillList = () => {
        setActionType(ActionTypeEnum.BILL_LIST)
    }
    const onWriteoffList = () => {
        setActionType(ActionTypeEnum.WRITEOFF_LIST)
    }
    const onLogList = () => {
        setActionType(ActionTypeEnum.LOG_LIST)
    }
    const classname = (type: ActionTypeEnum) => {
        return 'tab-item ' + (actionType === type ? 'tab-active' : '')
    }

    const action = (
        <>
            <Button
                className={classname(ActionTypeEnum.ACCOUNT)}
                type="link"
                shape="round"
                onClick={onAccountList}
            >
                账户信息
            </Button>
            <Button
                className={classname(ActionTypeEnum.ADJUST_LIST)}
                type="link"
                shape="round"
                onClick={onAdjustList}
            >
                调额记录
            </Button>
            <Button
                className={classname(ActionTypeEnum.RECHARGE_LIST)}
                type="link"
                shape="round"
                onClick={onRechargeList}
            >
                充值记录
            </Button>
            <Button
                className={classname(ActionTypeEnum.TRANSFER_LIst)}
                type="link"
                shape="round"
                onClick={onTransferList}
            >
                转账记录
            </Button>
            <Button
                className={classname(ActionTypeEnum.BILL_LIST)}
                type="link"
                shape="round"
                onClick={onBillList}
            >
                账单信息
            </Button>
            <Button
                className={classname(ActionTypeEnum.WRITEOFF_LIST)}
                type="link"
                shape="round"
                onClick={onWriteoffList}
            >
                核销记录
            </Button>
            <Button
                className={classname(ActionTypeEnum.LOG_LIST)}
                type="link"
                shape="round"
                onClick={onLogList}
            >
                操作日志
            </Button>
        </>
    );
    const desc: IDescription[] = [
        {
            label: "可用额度合计",
            value: supplier?.totalAvailableAmount ?? 0.00,
            color: DescriptionColorEnum.green
        },
        {
            label: "欠款总计",
            value: supplier?.totalDebtAmount ?? 0.00,
            color: DescriptionColorEnum.red
        },
    ]

    return (
        <YhBox
            title={supplier?.name ?? " "}
            descriptions={desc}
            action={action}
        />
    )
}
